import { createSelector } from 'reselect';

import prop from 'lodash/fp/prop';

export default createSelector([prop('loading')], isLoading => isLoading);
